module.exports = __webpack_public_path__ + "static/media/HowItWorkImage3.15d58c6c.jpg";